import { SearchQuoteFilter } from '../list/searchQuotes';
import { apiFetch } from '@ami/react/core';
const baseUrl = 'quotes/view';

export const quoteReOpeningStatus = Object.freeze({
  allowed: 1,
  forbidden: 2,
  forbiddenForDealer: 3,
});

export const userType = Object.freeze({
  AMI: 'AMI',
  Dealer: 'Dealer',
});

export default class QuoteView {
  constructor(json) {
    Object.keys(json).map((key) => (this[key] = json[key]));
  }

  static async get(id) {
    const result = await apiFetch(`${baseUrl}/${id}`);
    return new QuoteView(result);
  }

  async downloadPdf() {
    const blob = await apiFetch(`${baseUrl}/${this.id}/pdf`, 'GET', null, {
      contentType: 'application/pdf',
    });
    return blob;
  }

  async downloadMsrpOnlyPdf() {
    const blob = await apiFetch(
      `${baseUrl}/${this.id}/pdf?msrpOnly=true`,
      'GET',
      null,
      {
        contentType: 'application/pdf',
      }
    );
    return blob;
  }

  async downloadAsPdfWithNoLeadTimes() {
    const blob = await apiFetch(
      `${baseUrl}/${this.id}/pdf?withNoLeadTimes=true`,
      'GET',
      null,
      {
        contentType: 'application/pdf',
      }
    );
    return blob;
  }

  getRevisionPdfDownloadUrl(revisionNumber) {
    return apiFetch(`quotes/${this.id}/revision/${revisionNumber}`);
  }

  static downloadCsv(filter) {
    const payload = new SearchQuoteFilter(filter.toPayload());
    return apiFetch(`${baseUrl}/csv?${payload.toQueryString()}`, 'GET', null, {
      contentType: 'text/csv',
    });
  }

  static downloadDetailsCsv(filter) {
    const payload = new SearchQuoteFilter(filter.toPayload());
    return apiFetch(`${baseUrl}/csv/details?${payload.toQueryString()}`, 'GET', null, {
      contentType: 'text/csv',
    });
  }
}
